
import noTokenRequest from '@/utils/request/noTokenRequest'
export function loginApi(data) {
    return noTokenRequest({
        url: '/console/login',
        method: 'post',
        data
    })
}
export function dashboard(data) {
    return noTokenRequest({
        url: '/console/dashboard',
        method: 'post',
        data
    })
}